// An otter, modelled facing +X: a sleek brown body with a pale chin, small round
// ears and a thick tapering tail. Ported 1:1 from age-of-mcp's classic otter.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#5a4030",
      position: [0, 0.024, 0], scale: [2, 0.8, 0.85] },             // sleek body
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#67492f",
      position: [0.055, 0.034, 0] },                                 // head
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#cdb89a",
      position: [0.066, 0.026, 0], scale: [0.8, 0.8, 1.1] },        // pale chin
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#3a2818",
      position: [0.05, 0.05, 0.014] },                              // ear
    { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#3a2818",
      position: [0.05, 0.05, -0.014] },
    { geometry: new THREE.ConeGeometry(0.018, 0.07, 5), color: "#503826",
      position: [-0.07, 0.024, 0], rotation: [0, 0, Math.PI / 2] },    // thick tail
  ];
}

export const otter = defineModel({
  id: "otter",
  scale: 2.18, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Otter",
  tags: ["creature","otter","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly otter.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
